export const theme = {
  container: {
    position: 'relative'
  },
  input: {
    width: '100%',
    height: 41,
    padding: '10px 20px',
    fontFamily: 'Open Sans, sans-serif',
    fontWeight: 300,
    fontSize: 20,
    border: '1px solid #aaa',
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
  },
  inputFocused: {
    outline: 'none'
  },
  inputOpen: {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0
  },
  suggestionsContainer: {
    display: 'none'
  },
  suggestionsContainerOpen: {
    display: 'block',
    position: 'absolute',
    top: 40,
    width: '100%',
    border: '1px solid #aaa',
    backgroundColor: '#fff',
    fontFamily: 'Open Sans, sans-serif',
    fontWeight: 300,
    fontSize: 16,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    zIndex: 2
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: 'none',
  },
  suggestion: {
    cursor: 'pointer',
    padding: '0px 20px'
  },
  suggestionHighlighted: {
    backgroundColor: '#E5F0E7' //personally, c8e6c9 matches closer to the side date color
  }
};
